import "../Stylesheets/Aside/Aside.css"
import {Link, NavLink} from "react-router-dom"
import {BarChart, Bell, ChatLeftDots, Hammer, House, Mouse, People, PersonLock, Eye} from "react-bootstrap-icons"
import { useSelector } from "react-redux"

const Aside = ({showFullWidth}) => {
    const user = useSelector(state => state.user);

    return(
        <div className="aside-modal-content">
            <Link to="/"><img src={showFullWidth ? "/static/icons/logo.png" : "/static/icons/logo-minimized.png"} className={`aside-logo ${showFullWidth ? "" : "aside-logo-minimized"}`} alt="logo"/></Link>
            <div className="navigation-container">
                <nav className="aside-navigation">
                    <ul className={`aside-navbar-list ${showFullWidth ? '' : 'minimized-aside'}`}>
                        <li><NavLink to="/"><House /> <span>Dashboard</span></NavLink></li>
                        <li><NavLink to="/users"><People /> <span>Users</span></NavLink></li>
                        <li><NavLink to="/accounts"><PersonLock /> <span>Account</span></NavLink></li>
                        <li><NavLink to="/watchlist"><Eye /> <span>Watchlist</span></NavLink></li>
                        <li><NavLink to="/bids-history"><Hammer /> <span>Bids History</span></NavLink></li>
                        <li><NavLink to="/won-vehicles"><img src="/static/svg/win-icon.svg" alt="won" style={{height: "18px", width: "18px", marginRight: "10px"}} /> <span>Won Cars</span></NavLink></li>
                        <li><NavLink to="/actions-history"><Mouse /> <span>Actions History</span></NavLink></li>
                        {user.role == "admin" && <li><NavLink to="/alerts"><ChatLeftDots /> <span>Alerts</span></NavLink></li>}
                        {user.role == "admin" && <li><NavLink to="/notifications"><Bell /> <span>Notifications</span></NavLink></li>}
                        <li><NavLink to="/statistics"><BarChart /> <span>Statistics</span></NavLink></li>
                    </ul>
                </nav>
            </div>
        </div>
    )
}

export default Aside